<template>
	<div :class="$style.container">
		<div v-if="isLoading" class="ui inverted active dimmer">
			<div class="ui centered inline loader text">Cargando</div>
		</div>
		<slot />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('menu', ['isOpen'], ['isLoading']),
		...mapGetters('app', ['isLoading', 'getTitulo'])
	}
};
</script>
<style lang="scss" module>
@import '@design';

.marginlefting {
	margin-left: 60px !important;
}
</style>
